import { takeEvery } from 'redux-saga'
import { call, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import fetcher from 'modules/fetcher'
// eslint-disable-next-line no-restricted-imports -- saga runs outside React render
import { t } from 'i18n/utils'

import {
  quickFillTemplateCreate,
  quickFillTemplateCreateFailure,
  quickFillTemplateUpdate,
  quickFillTemplateUpdateFailure,
  quickFillTemplateDelete,
  quickFillTemplateDeleteFailure
} from './actions'

import { notify } from 'utils/notify'
import {
  QUICK_FILL_TEMPLATE_CREATE_SUBMIT,
  QUICK_FILL_TEMPLATE_UPDATE_SUBMIT,
  QUICK_FILL_TEMPLATE_DELETE_SUBMIT,
  QUICK_FILL_TEMPLATE_SORT_SUBMIT
} from './constants'

export function * createSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      'api/v3/admin/quick_fill_templates',
      {
        method: 'POST',
        body: JSON.stringify({ quick_fill_template: payload })
      }
    )
    yield put(quickFillTemplateCreate(response))
    notify(t('admin.quickFills.createSuccess'))
    yield put(push(`/admin/modern/quick_fills/${response.record_type}`))
  } catch (e) {
    yield put(quickFillTemplateCreateFailure(e.message))
    notify(t('admin.quickFills.saveFailed'), { type: 'error' })
  }
}

export function * watchCreateSaga () {
  yield call(takeEvery, QUICK_FILL_TEMPLATE_CREATE_SUBMIT, createSaga)
}

export function * updateSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      `api/v3/admin/quick_fill_templates/${payload.id}`,
      {
        method: 'PUT',
        body: JSON.stringify({ quick_fill_template: payload })
      }
    )
    yield put(quickFillTemplateUpdate(response))
    if (!payload.skipRedirect) {
      notify(t('admin.quickFills.updateSuccess'))
      yield put(push(`/admin/modern/quick_fills/${response.record_type}`))
    }
  } catch (e) {
    yield put(quickFillTemplateUpdateFailure(e.message))
    notify(t('admin.quickFills.saveFailed'), { type: 'error' })
  }
}

export function * watchUpdateSaga () {
  yield call(takeEvery, QUICK_FILL_TEMPLATE_UPDATE_SUBMIT, updateSaga)
}

export function * deleteSaga ({ payload }) {
  try {
    yield call(
      fetcher,
      `api/v3/admin/quick_fill_templates/${payload.id}`,
      {
        method: 'DELETE',
        body: JSON.stringify({})
      }
    )
    yield put(quickFillTemplateDelete(payload))
    notify(t('admin.quickFills.deleteSuccess'))
    if (!payload.skipRedirect) {
      yield put(push(`/admin/modern/quick_fills/${payload.record_type}`))
    }
  } catch (e) {
    yield put(quickFillTemplateDeleteFailure(e.message))
    notify(t('admin.quickFills.deleteFailed'), { type: 'error' })
  }
}

export function * watchDeleteSaga () {
  yield call(takeEvery, QUICK_FILL_TEMPLATE_DELETE_SUBMIT, deleteSaga)
}

export function * sortSaga ({ payload }) {
  const { order, record_type } = payload
  try {
    yield call(
      fetcher,
      'api/v3/admin/quick_fill_templates/sort',
      {
        method: 'PUT',
        body: JSON.stringify({ order, record_type })
      }
    )
  } catch (e) {
    notify(t('admin.quickFills.saveFailed'), { type: 'error' })
  }
}

export function * watchSortSaga () {
  yield call(takeEvery, QUICK_FILL_TEMPLATE_SORT_SUBMIT, sortSaga)
}
